import { Injectable } from '@angular/core';
import { CustomPageResolverService } from 'gung-standard';
import { ColmecStartupCustomPageTemplateComponent } from '../components/colmec-startup-custom-page-template/colmec-startup-custom-page-template.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecCustomPageResolverService extends CustomPageResolverService {
  public getLayouts(): { name; componentDisplay }[] {
    const layouts = super.getLayouts();
    layouts.push({
      name: 'colmechomedefault',
      componentDisplay: ColmecStartupCustomPageTemplateComponent
    });
    return layouts;
  }
}
